import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Text } from '../../../shared/uiComponents';

interface Client {
	fullName: string;

	id: string;
}

interface ClientsListCardProps {
	clients: Client[];
}

const ClientsListCard: FC<ClientsListCardProps> = ({ clients }) => (
	<div className="insuranceDetailCard">
		<Text title={`Clients (${clients.length})`} type="h6" fontWeight="semiBold" />
		<div className="listContainer">
			{clients.length > 0 ? (
				clients.map((client) => (
					<div key={client.id} className="listItem">
						<Link to={`/clients/client/${client.id}`} className="listLink">
							{client.fullName}
						</Link>
					</div>
				))
			) : (
				<Text title="No clients" type="psm" color="#999" />
			)}
		</div>
	</div>
);

export default ClientsListCard;
